module.exports = __webpack_public_path__ + "static/ebook-contact-a513fbe61ab3813999f70946ef895014.jpg";